// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const ApprovalSchemeComponentService = {};

 

ApprovalSchemeComponentService.getApprovalSchemeComponentService = function (data) {
  
    return lossClient({
      url:
        "/ApprovalSchemeComponent/search?approvalschemeid=" +
        data?.approvalschemeid +
        "&description=" +
        data?.description ,
      method: "get",
    });
  };

export default ApprovalSchemeComponentService;
